<template>
  <div class="flowContainer">
    <div class="header">
      <div class="title">交易流水查询</div>
    </div>
    <div class="searchFrom">
      <el-form inline class="inline-form" :model="flowForm" label-width="80px" label-position="left">
        <div>
          <el-form-item label="时间">
            <cumstom-date-time-range :type="0" @change="changeDateTimeRange" @typeChange="search"></cumstom-date-time-range>
          </el-form-item>
        </div>
        <div v-if="shopType">
          <el-form-item label="门店">
            <el-select v-model="flowForm.merchantId" placeholder="请选择" style="width:310px;" @change="fetchCashierList(flowForm.merchantId)" size="small">
              <el-option v-for="item in shopList" :key="item.merchantId" :label="item.merchantName" :value="item.merchantId"> </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="收银点">
            <custom-select v-model="flowForm.cashierAreaList" :list="cashierList" type="1"> </custom-select>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="交易渠道" class="middleSele">
            <el-select v-model="flowForm.transType" placeholder="请选择" @change="changeChannel" style="width:100px;margin-right:16px;" size="small">
              <el-option label="扫码" value="0"> </el-option>
              <el-option label="刷卡" value="1"> </el-option>
            </el-select>
            <el-select v-model="flowForm.payType" multiple placeholder="请选择" style="width:340px;" size="small">
              <template v-if="flowForm.transType === '1'">
                <el-option label="刷卡" value="0"> </el-option>
              </template>
              <template v-else>
                <el-option label="微信" value="0"> </el-option>
                <el-option label="支付宝" value="1"> </el-option>
                <el-option label="银联二维码" value="2"> </el-option>
                <el-option label="数字人民币" value="9"> </el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="交易单号" class="middleSele">
            <el-input v-model="flowForm.leshuaOrderId" placeholder="请输入交易单号" style="width:310px;" size="small"></el-input>
          </el-form-item>
          <el-form-item label="交易金额" class="transAmount" size="small">
            <el-input v-model="flowForm.minTransAmount" placeholder="最小交易金额" style="width:147px;" @change="minAmount"></el-input>
            <span class="line"></span>
            <el-input v-model="flowForm.maxTransAmount" placeholder="最大交易金额" style="width:147px;" @change="maxAmount"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="设备编号" class="middleSele">
            <el-select v-model="flowForm.transToolNum" filterable placeholder="请选择设备编号" clearable size="small">
              <el-option v-for="item in deviceNumber" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="交易状态">
            <el-select v-model="flowForm.transStatus" placeholder="请选择" style="width:310px;" size="small">
              <template v-if="flowForm.transType == 0 && flowForm.cashierAreaList.length === 0">
                <el-option label="交易初始" value="0"> </el-option>
                <el-option label="支付成功" value="1"> </el-option>
                <el-option label="支付失败" value="2"> </el-option>
                <el-option label="退款成功" value="3"> </el-option>
                <el-option label="退款失败" value="4"> </el-option>
                <el-option label="退款中" value="5"> </el-option>
                <el-option label="撤销成功" value="6"> </el-option>
              </template>
              <template v-if="flowForm.transType == 1 && flowForm.cashierAreaList.length === 0">
                <el-option label="交易初始" value="0"> </el-option>
                <el-option label="支付成功" value="5"> </el-option>
                <el-option label="支付失败" value="11"> </el-option>
                <el-option label="冲正成功" value="53"> </el-option>
                <el-option label="退款成功" value="3"> </el-option>
                <el-option label="退款中" value="31"> </el-option>
                <el-option label="退款失败" value="32"> </el-option>
              </template>
              <!-- 当选择了收银点选项,只保留支付成功和退款成功 -->
              <template v-else-if="flowForm.transType == 0 && flowForm.cashierAreaList.length !== 0">
                <el-option label="支付成功" value="1"> </el-option>
                <el-option label="退款成功" value="3"> </el-option>
              </template>
              <template v-else-if="flowForm.transType == 1 && flowForm.cashierAreaList.length !== 0">
                <el-option label="支付成功" value="5"> </el-option>
                <el-option label="退款成功" value="3"> </el-option>
              </template>
            </el-select>
          </el-form-item>
          <span class="btnBox">
            <el-button type="primary" @click="search" class="btnBase" :disabled="btnCanNotClick" :class="{ saveBtnActive: btnCanNotClick }">查询</el-button>
            <el-button type="primary" class="btnBase" v-loading="exportLoading" :class="{ saveBtnActive: btnCanNotClick }" @click="exportTable(vm)" :disabled="btnCanNotClick">导出</el-button>
          </span>
        </div>
      </el-form>
    </div>
    <div class="tableData">
      <div class="tableDataCon">
        <el-table :data="tableData" style="width: 100%" border v-loading="loadingTable">
          <el-table-column prop="transTime" label="交易时间" align="center"></el-table-column>
          <el-table-column prop="leshuaOrderId" label="交易单号" align="center"></el-table-column>
          <el-table-column prop="shopTypeValue" label="交易门店" align="center"></el-table-column>
          <el-table-column prop="cashierAreaName" label="收银点" align="center" v-if="showCashierColumn"></el-table-column>
          <el-table-column prop="transAmount" label="交易金额" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.transAmount / 100 }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="payTypeValue" label="交易渠道" align="center"></el-table-column>
          <el-table-column prop="transStatusValue" label="交易状态" align="center"></el-table-column>
          <el-table-column label="详情" align="center">
            <template slot-scope="scope">
              <div class="viewDetial" @click="viewFlowDetial(scope.row)">查看</div>
            </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" class="paginationBox">
          <el-pagination
            v-if="page.count > 0"
            class="pagination"
            prev-text="上一页"
            next-text="下一页"
            :page-size="page.pageSize"
            layout="prev, pager,total,next"
            :total="page.count"
            :current-page="page.pageNo"
            @current-change="onChangeCurrentPage"
          >
          </el-pagination>
        </el-col>
      </div>
    </div>
    <div class="viewDetial">
      <el-dialog title="交易详情" :visible.sync="dialogViewDetial" width="30%">
        <div class="content">
          <div class="onePart">
            <div class="itemInfo">
              <span class="title">交易单号</span><span class="text">{{ transDetial.leshuaOrderId }}</span>
            </div>
            <div class="itemInfo">
              <span class="title">{{ transDetial.payTypeValue }}单号</span><span class="text">{{ transDetial.channelTransactionId }}</span>
            </div>
            <div class="itemInfo">
              <span class="title">银行单号</span><span class="text">{{ transDetial.channelOrderId }}</span>
            </div>
          </div>
          <div class="onePart">
            <div class="itemInfo">
              <span class="title">商户编号</span><span class="text">{{ transDetial.merchantId }}</span>
            </div>
            <div class="itemInfo">
              <span class="title">门店名称</span><span class="text">{{ transDetial.merchantName }}</span>
            </div>
            <div class="itemInfo">
              <span class="title">门店类型</span><span class="text">{{ transDetial.shopTypeValue }}</span>
            </div>
          </div>
          <div class="onePart">
            <div class="itemInfo">
              <span class="title">交易时间</span><span class="text">{{ transDetial.transTime }}</span>
            </div>
            <div class="itemInfo">
              <span class="title">交易状态</span><span class="text">{{ transDetial.transStatusValue }}</span>
            </div>
            <div class="itemInfo">
              <span class="title">交易渠道</span><span class="text">{{ transDetial.payTypeValue }}</span>
            </div>
            <div class="itemInfo">
              <span class="title">收款设备</span><span class="text">{{ transDetial.transToolCustomerName }}</span>
            </div>
            <div class="itemInfo">
              <span class="title">设备编号</span><span class="text">{{ transDetial.transToolNum }}</span>
            </div>
            <div class="itemInfo">
              <span class="title">交易金额</span><span class="text">{{ transDetial.transAmount / 100 }}</span>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogViewDetial = false">知道了</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import CumstomDateTimeRange from "@/components/CustomDateTimeRange/index.vue";
import CustomSelect from "@/components/CustomSelect/index.vue";
import { queryShopList } from "@/api/merchant-info";
import { listTransDetail, listAllTransToolByMerchantId, fetchCashiers } from "@/api/flow";
import {
  formatDatehour, debounce, downLoadFileByForm, formatDate,
} from "@/utils/index";
import { host } from "@/global-config";

export default {
  components: {
    CumstomDateTimeRange,
    CustomSelect,
  },
  data() {
    return {
      // 新增的收银点列表
      cashierList: [],
      transDetial: {
        leshuaOrderId: "",
        channelTransactionId: "",
        channelOrderId: "",
        merchantId: "",
        merchantName: "",
        shopTypeValue: "",
        transTime: "",
        transStatusValue: "",
        payTypeValue: "",
        transToolName: "",
        transQrcodeNum: "",
        transAmount: "",
      },
      showCashierColumn: false,
      flowForm: {
        transStartTime: "",
        transEndTime: "",
        transType: "0",
        transStatus: "1",
        minTransAmount: "",
        maxTransAmount: "",
        transToolNum: "",
        leshuaOrderId: "",
        merchantId: "",
        payType: ["0", "1", "2", '9'],
        cashierAreaList: [],
      },
      dialogViewDetial: false,
      loadingTable: false,
      page: {
        pageNo: 1,
        count: 0,
        pageSize: 10,
      },
      tableData: [],
      shopList: [],
      deviceNumber: [],
      exportLoading: false,
      vm: this,
      btnCanNotClick: false,
      shopType: 1,
    };
  },
  watch: {
    "flowForm.merchantId": {
      deep: true,
      handler(newVal) {
        this.getDeviceInfo(newVal);
      },
    },
    // flowForm: {
    //   deep: true,
    //   handler(newVal) {
    //     if (newVal.cashierAreaList.length !== 0) {
    //       console.log(1);
    //     }
    //   },
    // },
  },
  methods: {
    // 根据商户号查询更新收银点
    fetchCashierList(id) {
      // const param = { merchantId: [id] };
      this.flowForm.cashierAreaList = [];
      fetchCashiers([id]).then((res) => {
        // console.log(res);
        if (res.data.error_code === 0) {
          if (res.data.data.list.length === 0) {
            this.showCashierColumn = false;
          } else {
            this.showCashierColumn = true;
            res.data.data.list.unshift({ cashierAreaNo: "@", cashierAreaName: "全部收银点" });
          }
          // this.flowForm.cashierAreaNo = ["@"];
          this.cashierList = res.data.data.list;
        }
      });
    },
    // 交易渠道
    changeChannel(val) {
      if (val === "0") {
        this.flowForm.payType = ["0", "1", "2"];
        this.flowForm.transStatus = "1";
      } else {
        this.flowForm.payType = ["0"];
        this.flowForm.transStatus = "5";
      }
    },
    minAmount(val) {
      //  必须正数，可以为小数，
      const reDigital = /^\d+(?=\.{0,1}\d+$|$)/;
      const nowVal = parseFloat(val, 10);
      const max = parseFloat(this.flowForm.maxTransAmount, 10);
      if (!reDigital.test(val) && val !== "") {
        this.$message({
          showClose: true,
          message: "请输入正确的交易金额",
          type: "error",
        });
      } else if (val && nowVal > max && this.flowForm.maxTransAmount !== "") {
        this.$message({
          showClose: true,
          message: "最小交易金额不能大于最大交易金额",
          type: "error",
        });
      }
    },
    maxAmount(val) {
      const reDigital = /^\d+(?=\.{0,1}\d+$|$)/;
      const nowVal = parseFloat(val, 10);
      const min = parseFloat(this.flowForm.minTransAmount, 10);
      if (!reDigital.test(val) && val !== "") {
        this.$message({
          showClose: true,
          message: "请输入正确的交易金额",
          type: "error",
        });
      } else if (val && nowVal < min && this.flowForm.minTransAmount !== "") {
        this.$message({
          showClose: true,
          message: "最大交易金额不能小于最小交易金额",
          type: "error",
        });
      }
    },

    changeDateTimeRange(dateTimeRange) {
      const date = new Date().getTime();
      // 日期是否包含今天
      if (formatDate(date) === formatDate(dateTimeRange[1])) {
        this.flowForm.transStartTime = formatDatehour(dateTimeRange[0]);
        this.flowForm.transEndTime = formatDatehour(dateTimeRange[1]);
      } else {
        this.flowForm.transStartTime = formatDatehour(dateTimeRange[0]);
        this.flowForm.transEndTime = formatDatehour(dateTimeRange[1]);
      }
    },
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage(page) {
      this.page.pageNo = page;
      this.queryData();
    },
    search() {
      // if (this.flowForm.cashierAreaNo.length === 0) {
      //   this.showCashierColumn = false;
      // } else {
      //   this.showCashierColumn = true;
      // }
      this.page.pageNo = 1;
      const reDigital = /^\d+(?=\.{0,1}\d+$|$)/;
      if (this.flowForm.minTransAmount !== "" && !reDigital.test(this.flowForm.minTransAmount)) {
        this.$message({
          showClose: true,
          message: "请输入正确的交易金额",
          type: "error",
        });
      } else if (this.flowForm.maxTransAmount !== "" && !reDigital.test(this.flowForm.maxTransAmount)) {
        this.$message({
          showClose: true,
          message: "请输入正确的交易金额",
          type: "error",
        });
      } else if (this.flowForm.maxTransAmount !== "" && this.flowForm.minTransAmount !== "" && this.flowForm.maxTransAmount < this.flowForm.minTransAmount) {
        this.$message({
          showClose: true,
          message: "最大交易金额不能小于最小交易金额",
          type: "error",
        });
      } else {
        this.queryData();
      }
    },
    // 导出
    exportTable: debounce(
      (vm) => {
        const reDigital = /^\d+(?=\.{0,1}\d+$|$)/;
        if (vm.flowForm.minTransAmount !== "" && !reDigital.test(vm.flowForm.minTransAmount)) {
          vm.$message({
            showClose: true,
            message: "请输入正确的交易金额",
            type: "error",
          });
        } else if (vm.flowForm.maxTransAmount !== "" && !reDigital.test(vm.flowForm.maxTransAmount)) {
          vm.$message({
            showClose: true,
            message: "请输入正确的交易金额",
            type: "error",
          });
        } else if (vm.flowForm.maxTransAmount !== "" && vm.flowForm.minTransAmount !== "" && vm.flowForm.maxTransAmount < vm.flowForm.minTransAmount) {
          vm.$message({
            showClose: true,
            message: "最大交易金额不能小于最小交易金额",
            type: "error",
          });
        } else {
          vm.exportList();
        }
      },
      200,
      true,
    ),
    exportList() {
      const loginInfo = JSON.parse(window.localStorage.getItem("LOGIN_INFO"));
      const { userName, sessionId } = loginInfo;
      const url = `${host}/trans/exportTransList?userName=${userName}&sessionId=${sessionId}`;
      const param = Object.assign({}, this.flowForm);
      console.log(param, "flow导出的param");
      if (param.cashierAreaList[0] === "@") {
        param.cashierAreaList = [];
        this.cashierList.forEach((v) => {
          if (v.cashierAreaNo !== "@") {
            param.cashierAreaList.push(v.cashierAreaNo);
          }
        });
      }
      downLoadFileByForm(url, param);
      this.exportLoading = false;
    },
    // 获取门店列表
    queryShopList() {
      const params = {
        userName: "",
        merchantName: "",
        merchantId: "",
        pageNo: 1,
        pageSize: 1000,
      };
      queryShopList(params).then((res) => {
        if (res.data.error_code === 0) {
          this.shopList = res.data.data.list;
          this.flowForm.merchantId = this.shopList[0].merchantId;
          this.fetchCashierList(this.flowForm.merchantId);

          this.queryData();
        }
      });
    },
    getDeviceInfo(value) {
      const params = { merchantId: value };
      listAllTransToolByMerchantId(params).then((res) => {
        if (res.data.error_code === 0) {
          this.deviceNumber = res.data.data;
        }
      });
    },
    queryData() {
      Object.assign(this.flowForm, this.page);
      const param = Object.assign({}, this.flowForm);
      if (param.cashierAreaList[0] === "@") {
        param.cashierAreaList = [];
        this.cashierList.forEach((v) => {
          if (v.cashierAreaNo !== "@") {
            param.cashierAreaList.push(v.cashierAreaNo);
          }
        });
      }
      if (param.minTransAmount !== "") {
        param.minTransAmount *= 100;
      }
      if (param.maxTransAmount !== "") {
        param.maxTransAmount *= 100;
      }
      this.loadingTable = true;
      listTransDetail(param).then((res) => {
        this.loadingTable = false;
        if (res.data.error_code === 0) {
          this.tableData = res.data.data.list;
          this.page.count = res.data.data.totalCount;
        }
      });
    },
    // 查看详情
    viewFlowDetial(row) {
      this.dialogViewDetial = true;
      this.transDetial = row;
    },
  },
  mounted() {
    this.queryShopList();
    if (JSON.parse(window.localStorage.getItem("LOGIN_INFO"))) {
      this.shopType = JSON.parse(window.localStorage.getItem("LOGIN_INFO")).shopType;
    }
    // this.fetchCashierList(this.flowForm.merchantId);
  },
};
</script>
<style lang="scss">
.flowContainer {
  > .header {
    padding-left: 50px;
    background-color: #fff;
    .title {
      height: 80px;
      line-height: 80px;
      color: #333333;
      font-size: 18px;
      position: relative;
      &:after {
        content: "";
        display: block;
        height: 0px;
        border-bottom: 1px solid #f2f3f3;
        right: 0;
        bottom: 0;
        left: -50px;
        position: absolute;
      }
    }
  }
  .searchFrom {
    padding: 40px 50px 20px 50px;
    overflow: hidden;
    border-bottom: 20px solid #eee;
    .el-form-item.el-form-item__label {
      height: 32px;
      line-height: 32px;
      font-size: 14px;
    }
    .timeLable {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }
    .el-form--inline .el-form-item__label {
      color: #333333;
      font-size: 14px;
      font-weight: 400;
      .el-form-item__content {
        overflow: hidden;
      }
    }
    .el-tag__close {
      font-size: 16px;
    }
    .middleSele {
      margin-right: 40px;
    }
    .transAmount {
      margin-top: 3px;
      .el-form-item__content {
        border: 1px solid #dcdfe6;
        border-radius: 4px;
      }
      .el-input__inner {
        border: none;
      }
    }
    .btnBase {
      background: #ff9c00;
      width: 90px;
      height: 32px;
      line-height: 0px;
      border: none;
    }
    .saveBtnActive {
      background: #ececec;
      color: #666;
    }
    .btnBox {
      float: right;
    }
    .line {
      margin-right: 10px;
      background: #999999;
      width: 10px;
      height: 2px;
      display: inline-block;
      vertical-align: middle;
    }
      .el-select .el-select__tags{
      margin-top: 4px;
    }
    .el-select .el-select__tags > span {
      display: flex;
    }
    .middleSele .el-select .el-select__tags{
        margin-top: 0px;
      }
    .el-tag.el-tag--info {
      max-width: 100%;
      display: flex;
      align-items: center;
    }
  }
  .tableData {
    background: #f7f7f7;
    overflow: hidden;
    .tableDataCon {
      padding: 40px 50px;
      background: #fff;
      overflow: hidden;
      .viewDetial {
        color: #ff9c00;
        cursor: pointer;
      }
    }
  }
  .viewDetial {
    .el-dialog {
      border-radius: 6px;
    }
    .el-dialog__header {
      padding: 40px 30px 0 40px;
    }
    .el-dialog__body {
      padding: 00px 30px 0 40px;
    }
    .el-dialog__footer {
      text-align: center;
      margin-top: 45px;
      padding-bottom: 50px;
      .el-button {
        width: 120px;
        height: 38px;
        background: #ff9c00;
        border: none;
      }
    }
    .content {
      .onePart {
        margin-top: 35px;
        font-size: 14px;
        .itemInfo {
          margin-top: 20px;
          display: flex;
        }
        .title {
          color: #999999;
          width: 100px;
        }
        .text {
          color: #333333;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
